import * as React from "react";
import { KubernetesAgentTargetTagsContextualHelp, WorkerPoolsContextualHelp } from "~/components/ContextualHelp/ContextualHelpSnippets";
export const ConfigurationMessages = {
    Name: {
        DeploymentTarget: {
            Validation: {
                AlreadyExists: "A deployment target with this name already exists. Please choose a different name.",
                NotProvided: "Please enter a name for this deployment target",
            },
            HelperText: "You can use the same name as your Kubernetes cluster",
        },
        Worker: {
            Validation: {
                AlreadyExists: "A worker with this name already exists. Please choose a different name.",
                NotProvided: "Please enter a name for this worker",
            },
            HelperText: "A short, memorable name for this worker.",
        },
    },
    EnvironmentIds: {
        Validation: {
            NotProvided: "Please select an environment for this deployment target.",
        },
        HelperText: "Select at least one environment",
    },
    MachineRoles: {
        Validation: {
            NotProvided: "Please select a target tag for this deployment target.",
        },
        HelperText: (<>
                Add at least one target tag <KubernetesAgentTargetTagsContextualHelp position="bottom-start"/>
            </>),
    },
    WorkerPools: {
        Validation: {
            NotProvided: "Please select a worker pool for this worker.",
        },
        HelperText: (<>
                <strong>Worker Pools</strong> <WorkerPoolsContextualHelp /> are groups of workers that execute tasks.
            </>),
    },
    WorkerPool: {
        Validation: {
            NotProvided: "Please enter a name for this worker pool.",
        },
        HelperText: "A short, memorable name for this worker pool.",
    },
    ServerUri: {
        Validation: {
            NotProvided: "Please enter the Octopus Deploy Server URL",
            Invalid: "Please enter a valid Octopus Deploy Server URL",
        },
        HelperText: "Provide the full URL to your Octopus Deploy instance.",
    },
    ServerGrpcUri: {
        Validation: {
            NotProvided: "Please enter the Octopus Deploy Server gRPC URL",
            Invalid: "Please enter a valid Octopus Deploy Server gRPC URL",
        },
        HelperText: "Provide the full gRPC URL to your Octopus Deploy instance.",
    },
    ServerCommsAddresses: {
        Validation: {
            NotProvided: "Please enter a Server Communications URL",
            Invalid: "Please enter a valid Server Communications URL",
            NotUnique: "Each Server Communications URL must be unique",
        },
        HelperText: "The URL of the Octopus Server that the Agent will poll for work.",
    },
} as const;
